import { render, staticRenderFns } from "./FormsPage.vue?vue&type=template&id=4436bc39&scoped=true&"
import script from "./FormsPage.vue?vue&type=script&lang=js&"
export * from "./FormsPage.vue?vue&type=script&lang=js&"
import style0 from "./FormsPage.vue?vue&type=style&index=0&id=4436bc39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436bc39",
  null
  
)

export default component.exports